import React from 'react';
import { connect } from 'react-redux'

import { _setAxios } from '../../../lib/Helper';

import { Row, Col, Empty, Card, Button, Typography } from 'antd';
import { isMobile } from 'react-device-detect';

const { Title, Text } = Typography;

class TataTertib extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            file_active: null
        };
    }

    componentDidMount() {
        this.getFileActive()
    }

    getFileActive = () => {
        _setAxios("tatibsi/dokumen/file", "GET").then(resp => {
            if (resp.status === true) {
                const data = resp.data.data
                this.setState({
                    file_active: data && data.file ? data.main_path + data.file : null
                })
            }
        })
    }

    render() {

        if (isMobile) {
            return this.state.file_active ?
                <Card style={{ maxWidth: 600, margin: '20px auto', padding: '20px' }} bordered>
                    <Title level={3}>Informasi Tata Tertib</Title>
                    <Text>
                        Untuk memastikan pengalaman yang lebih baik dan sesuai aturan, kami telah menyiapkan
                        dokumen tata tertib yang perlu kamu perhatikan. Pastikan kamu membaca dan memahami semua
                        aturan yang ada.
                    </Text>
                    <div style={{ marginTop: '20px' }}>
                        <Button
                            type="primary"
                            href={this.state.file_active}
                            target="_blank"
                            block
                        >
                            Buka Tata Tertib PDF
                        </Button>
                    </div>
                </Card> : <Empty
                    imageStyle={{
                        height: 60,
                    }}
                    description={
                        <span>
                            Mohon maaf, belum ada file tata tertib yang aktif.
                        </span>
                    }
                >
                </Empty>
        }

        return (
            <Row>
                <Col span={24}>
                    {this.state.file_active ?
                        <embed src={this.state.file_active} type="application/pdf" style={{
                            width: "100%",
                            height: 720
                        }} /> : <Empty
                            imageStyle={{
                                height: 60,
                            }}
                            description={
                                <span>
                                    Mohon maaf, belum ada file tata tertib yang aktif.
                                </span>
                            }
                        >
                        </Empty>}
                </Col>
            </Row >
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(TataTertib);
